import { resolveApiUrl } from "~/utils/url/urlResolver";
import { type HousingSearchForm } from "~/features/selectionAssistant/housing/types/housingSAFormTypes";
import { transformSearchResults } from "~/features/search/transformers/SearchResultDataTransformer";
import { type SearchResultData } from "~/utils/models";
import { getUrlParamsFromFilters } from "~/features/selectionAssistant/housing/api/search/createHSASearchParams";
import { type RuntimeFilterDefinition } from "~/features/selectionAssistant/housing/types/FilterDefinitionV2";

const baseApiUrl = resolveApiUrl("/search/searchpage/pagedata");

export async function fetchHousingSearchResults(
  data: HousingSearchForm | null,
  filterMap: Record<string, RuntimeFilterDefinition> | null,
  pageSize?: number,
): Promise<SearchResultData> {
  let url;
  if (data && filterMap) {
    url = baseApiUrl + "?" + getUrlParamsFromFilters(data, filterMap, pageSize);
  } else {
    url = baseApiUrl + "?isSelectionAssistant=HOUSINGS";
  }

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  try {
    if (response.redirected) {
      window.location.reload();
    } else if (response.ok) {
      const data = await response.json();
      return transformSearchResults(data);
    }
  } catch (error) {
    console.error(error);
  }
  throw new Error(`Failed to receive search results with code: ${response.status}`);
}
